import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "@/lib/utils";

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("aero:flex aero:flex-col aero:gap-2", className)}
      {...props}
    />
  );
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "aero:bg-muted aero:text-muted-foreground aero:inline-flex aero:h-9 aero:w-fit aero:items-center aero:justify-center aero:!rounded-lg aero:p-[3px]",
        className
      )}
      {...props}
    />
  );
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "aero:data-[state=active]:bg-background aero:dark:data-[state=active]:text-foreground aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:focus-visible:outline-ring aero:dark:data-[state=active]:border-input aero:dark:data-[state=active]:bg-input/30 aero:text-foreground aero:dark:text-muted-foreground aero:inline-flex aero:h-[calc(100%-1px)] aero:flex-1 aero:items-center aero:justify-center aero:gap-1.5 aero:!rounded-md aero:border aero:border-transparent aero:px-2 aero:py-1 aero:text-sm aero:font-medium aero:whitespace-nowrap aero:transition-[color,box-shadow] aero:focus-visible:ring-[3px] aero:focus-visible:outline-1 aero:disabled:pointer-events-none aero:disabled:opacity-50 aero:data-[state=active]:shadow-sm aero:[&_svg]:pointer-events-none aero:[&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        className
      )}
      {...props}
    />
  );
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("aero:flex-1 aero:outline-none", className)}
      {...props}
    />
  );
}

export { Tabs, TabsList, TabsTrigger, TabsContent };
